<template>
  <div class="c-success-info">
    <component v-if="render" :is="render" v-bind="props"/>
    <p class="text" v-else>{{desc}}</p>

  </div>
</template>
<script>
import {
  defineComponent,
} from 'vue';

export default defineComponent({
  name: 'SuccessInfo',
  components: {
    // PrButton,
  },
  props: {
    desc: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '確定',
    },
    callback: {
      type: Function,
    },
    render: {

      default: null,
    },
    extraFunc: {
      default: null,
    },
    close: {
      type: Function,
      default: () => {},
    },

  },
  emits: ['closeDialog', 'loadingError'],
  setup(props, { emit }) {
    const closeDialog = () => {
      emit('closeDialog', 'loadingError');
    };

    const handleLeave = () => {
      closeDialog();
    };

    const handleConfirm = () => {
      handleLeave();
    };

    return {
      handleLeave,
      handleConfirm,
      // router,
      props,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-leave-self-checking-confirm {
  @include flex(center, center, column);
}
.text {
  @include font-normal();
  text-align: center;
}

.btn-wrap {
  margin-top: 50px;
}
</style>
